import { AvailabilityTimeQuery } from '@models/response/availabilityTime';
import { AvailabilityTimeQueryResponse, WeekDay } from '@models/ropolo';
import moment from 'moment';
import businessConfig from '../config/business';
import timeUtil from './timeUtil';

const isVendorOpen = (availabilityTimes: AvailabilityTimeQueryResponse[], isActive: boolean) => {
  const todayName = moment().format('ddd').toUpperCase() as WeekDay;

  const isOpen = availabilityTimes
    .filter((time) => time.dayOfWeek === todayName)
    .some((time: AvailabilityTimeQuery) => {
      const { startTime, endTime } = time;

      return timeUtil.isNowInRange(startTime || '', endTime || '');
    });

  return isOpen && isActive;
};

const parseVendorDomain = (domain: string) => {
  try {
    const hostname = new URL(`http://${domain}`).hostname.replace(/^www\./, ''); // ghahvebidar.project51.ir

    const configDomains = (businessConfig?.domain || '').split(',');

    const matchedConfig = configDomains.find((cfg) => hostname.endsWith(cfg)); // project51.ir

    if (matchedConfig) {
      const subdomain = hostname.replace(new RegExp(`\\.${matchedConfig}$`), ''); // ghahvebidar
      return subdomain;
    }

    return hostname;
  } catch (e) {
    console.error('Invalid domain format:', domain, e);
    return '';
  }
};

const getVendorDomain = () => {
  const reqDomain = new URL(`http://${window.location.hostname}`).hostname.replace('www.', '');

  const configDomains = businessConfig?.domain?.split(',');
  const matchedConfig = configDomains?.find((cfg) => reqDomain.endsWith(cfg));
  if (matchedConfig) {
    const subdomain = reqDomain.replace(new RegExp(`\\.${matchedConfig}$`), ''); // ghahvebidar
    return subdomain;
  }
  return reqDomain;
};

const getCurrentConfigDomain = (domain?: string) => {
  if (typeof window !== 'undefined') {
    const reqDomain = new URL(`http://${window?.location?.hostname}`).hostname.replace('www.', '');
    const configDomains = businessConfig?.domain?.split(',');
    const matchedConfig = configDomains?.find((cfg) => reqDomain.endsWith(cfg));
    return matchedConfig || '';
  }
  if (domain) {
    const reqDomain = new URL(`http://${domain}`).hostname.replace('www.', '');
    const configDomains = businessConfig?.domain?.split(',');
    const matchedConfig = configDomains?.find((cfg) => reqDomain.endsWith(cfg));
    return matchedConfig || '';
  }
  return '';
};

const generateApiUrl = (path: string, urlDomain?: string) => {
  let domain = '';

  if (!urlDomain) {
    domain = getCurrentConfigDomain();
  } else {
    domain = urlDomain;
  }

  if (domain === '') {
    // serverside
    return `${path}.snapp-store.com`;
  }

  if (domain === 'project51.ir') {
    return 'https://api.stage.project51.ir';
  }

  if (domain === 'localhost' || domain === 'ropolodev2.com' || domain === 'ropolodev.com') {
    return `${path}.snapp-store.com`;
  }
  return `${path}.${domain}`;
};

const VendorUtil = {
  isVendorOpen,
  parseVendorDomain,
  getVendorDomain,
  getCurrentConfigDomain,
  generateApiUrl,
};

export default VendorUtil;
